import { useEffect, useState } from 'react';
import Session from 'supertokens-auth-react/recipe/session';

export const useIsLoggedIn = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkLoggedIn = async () => {
      const result = await Session.doesSessionExist();
      setIsLoggedIn(result);
    };

    checkLoggedIn();
  }, []);

  return isLoggedIn;
};
